// Role: Patient
// Description: Resources viewer. Second tab in main menu.
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import ResourcesPage from 'containers/Resources/ResourcesPage';
import FaqPage from 'containers/Resources/FaqPage';

const Resources = ({ isData, match }) =>
  isData ? (
    <Switch>
      <Route exact path={match.url} component={ResourcesPage} />
      <Route exact path={`${match.url}/faq`} component={FaqPage} />
      <Route exact path={`${match.url}/faq/:groupId?/:resourceId?`} component={FaqPage} />
      <Route exact path={`${match.url}/:groupId/:resourceId?`} component={ResourcesPage} />
    </Switch>
  ) : null;

Resources.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
  isData: PropTypes.bool.isRequired,
};

export default Resources;
